import { ComponentProps } from 'react';
import { Label as AriaLabel } from 'react-aria-components';
import { Typography } from '../typography/typography';
import { TypographyVariants } from '../typography/variants';

type Props = {
  weight?: TypographyVariants['weight'];
  size?: TypographyVariants['variant'];
} & ComponentProps<typeof AriaLabel>;

export function Label(props: Props) {
  const { children, weight = 'regular', size = 'body-m', ...rest } = props;

  return (
    <AriaLabel {...rest}>
      <Typography as="span" variant={size} weight={weight}>
        {children}
      </Typography>
    </AriaLabel>
  );
}
